import React from "react";
import { Loader, PauseCircle } from "lucide-react";
import { toast } from "react-hot-toast";
import { useAllCampaignsPaused, useSetAllCampaignsPaused } from "../hooks/useCampaigns";

// One switch for every consumer campaign. Shows a banner while it is on.
const PauseAllCampaigns = () => {
  const { data: paused, isLoading } = useAllCampaignsPaused();
  const { mutate: setPaused, isPending } = useSetAllCampaignsPaused();

  const toggle = () => {
    const next = !paused;
    const message = next
      ? "Pause ALL consumer campaigns? Coupon campaigns and their banners, product update emails (a running send stops at its next batch) and the daily rate pushes will stop until you resume. Payout, deposit and KYC alerts are not affected."
      : "Resume all consumer campaigns? Paused product update emails stay paused until you resume each one.";
    if (!window.confirm(message)) return;
    setPaused(next, {
      onSuccess: () => toast.success(next ? "All consumer campaigns are paused" : "Consumer campaigns resumed"),
      onError: (err) => toast.error(err?.response?.data?.message || "Could not change the setting"),
    });
  };

  return (
    <div
      className={`flex flex-col gap-3 justify-between p-4 mb-5 rounded-xl border sm:flex-row sm:items-center ${
        paused ? "bg-amber-50 border-amber-200" : "bg-white border-gray-200"
      }`}
    >
      <div className="flex gap-3 items-start">
        <PauseCircle className={`mt-0.5 w-5 h-5 shrink-0 ${paused ? "text-amber-700" : "text-gray-500"}`} />
        <div>
          <p className="text-sm font-semibold text-gray-900">
            {paused ? "All consumer campaigns are paused" : "Pause all consumer campaigns"}
          </p>
          <p className="text-sm text-gray-600">
            Stops coupon campaigns and banners, product update emails and the daily rate pushes at once. Payout, deposit
            and KYC alerts keep going.
          </p>
        </div>
      </div>
      {isLoading ? (
        <Loader className="w-5 h-5 animate-spin" />
      ) : (
        <button
          type="button"
          onClick={toggle}
          disabled={isPending}
          className={`px-4 py-2 text-sm font-bold rounded-3xl transition-all disabled:opacity-50 shrink-0 ${
            paused ? "text-white bg-[#013941] hover:bg-[#012126]" : "text-red-700 bg-red-50 border border-red-200 hover:bg-red-100"
          }`}
        >
          {isPending ? "Saving" : paused ? "Resume all" : "Pause all"}
        </button>
      )}
    </div>
  );
};

export default PauseAllCampaigns;
